import { useEffect, useState } from 'react'

import { getManagedDealerships } from 'api/dealership'
import { ManagedDealership } from 'api/dealership/types'
import { OctaneLogger } from 'integrations/datadog/OctaneLogger'

export default function useManagedDealerships(): ManagedDealership[] {
    const [dealerships, setDealerships] = useState<ManagedDealership[]>([])

    useEffect(() => {
        let isMounted = true

        getManagedDealerships()
            .then((result: ManagedDealership[]) => {
                if (isMounted) {
                    setDealerships(result)
                }
            })
            .catch((error: Error) => {
                OctaneLogger.error(
                    'Failed to load managed dealerships for dealership filter',
                    {},
                    error,
                )
            })

        return () => {
            isMounted = false
        }
    }, [])

    return dealerships
}
